const setPageTitle = (title: string) => {
  document.title = title;
};

export default setPageTitle;
